<template>
  <div class="settings-page">
    <div class="settings-page__title">{{$tSettings('Settings')}}</div>
    <div v-if="pending" class="page__columns-inner container-inner">
      <div class="page__main-col">
        <BasePreloader/>
      </div>
    </div>
    <div v-else class="settings-page__inner">
      <div class="settings-page__left">
        <div class="settings-page__left-group-wrap">
          <div class="settings-page__left-group">
            <div class="settings-page__left-group-title">{{$tSettings('Smart search')}}</div>
            <SocialNetworksConnections v-if="connections"
                                       :data="connections"
                                       @update="load()" />
          </div>
        </div>
      </div>
      <div class="settings-page__right">
        <SettingsSide />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {mapState} from 'vuex'

  import SettingsSide from '../../components/SettingsSide'
  import SocialNetworksConnections from '../../components/SocialNetworksConnections'

  export default {
    name: 'AccountSettingsPage',
    components: {
      SocialNetworksConnections,
      SettingsSide
    },
    data() {
      return {
        pending: false,
        connections: null
      }
    },
    computed: {
      ...mapState(['aiToken']),
      ...mapState('user', ['profile']),
    },
    created() {
      this.load()
    },
    methods: {
      load(){
        this.pending = true;

        if(this.aiToken) {
          axios.get(`https://jobian-ai.whiteweb.com.ua/api/v1/front/status?user=${this.profile.id}`, {headers: {Authorization: 'Bearer ' + this.aiToken}})
            .then((data) => {
              if(data.status === 200) {
                this.connections = data.data.data;
              }
            })
            .catch((error) => {
              if(error) {console.log(error)}
            })
            .finally(()=>{this.pending = false})
        }
      },

    }

  };

</script>

<style lang="less">

</style>
